import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTheme } from '@shared/providers/theme/ThemeContext';

const ResetPasswordExpiredPage: React.FC = () => {
  const { site } = useParams<{ site: string }>();
  const { colors } = useTheme();

  return (
    <div className="flex items-center justify-center min-h-screen login-page-bg">
      <div className="w-full px-4 max-w-[460px] mt-2.5">
        <div className="mb-3 text-center">
          <img
            src="/images/login/logo.png"
            alt="RA2N Logo"
            className="mx-auto w-[380px] max-w-full"
          />
        </div>

        <div className="px-8 py-6 bg-white rounded-lg shadow-lg bg-opacity-95">
          <h2 className="mb-4 text-lg font-semibold text-center text-gray-800">
            パスワード再設定URLの有効期限切れ
          </h2>

          <div
            className="px-4 py-3 mb-4 text-red-700 border border-red-200 rounded bg-red-50"
            role="alert"
            data-testid="error-message"
          >
            パスワードリセット画面のURLの有効期限が切れています
          </div>

          <div className="text-center mt-4">
            <Link
              to={`/${site || 'medix'}/forgot-password`}
              className="text-sm hover:opacity-80"
              style={{ color: colors.primary }}
              data-testid="back-to-forgot-password"
            >
              パスワードリセットに戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordExpiredPage;
